import type { prefetchParams, prefetchParam } from '@micro-app/types'
import CreateApp, { appInstanceMap } from './create_app'
import { requestIdleCallback } from './libs/utils'
import microApp from './micro_app'

// 过滤符合条件的配置
function filterPreFetchTarget (apps: Array<prefetchParam>, validApps: Array<prefetchParam>) {
  if (toString.call(apps) === '[object Array]') {
    apps.forEach((item) => {
      if (
        toString.call(item) === '[object Object]' &&
        (item.name && typeof item.name === 'string') &&
        (item.url && typeof item.url === 'string') &&
        !appInstanceMap.has(item.name)
      ) {
        validApps.push(item)
      }
    })
  }
}

/**
 * 预加载
 * preFetch([
 *  {
 *    name: xx,
 *    url: xxx,
 *    disableScopecss: xx,
 *    disableSandbox: xx,
 *    macro: xx,
 *    shadowDOM: xx,
 *  },
 *  ...
 * ])
 * 注意：
 *  1、预加载是异步的，在浏览器空闲时才会执行
 *  2、预加载的 disableScopeCss、disableSandbox、macro、shadowDOM 和micro-app组件要保持一致，如果冲突，谁先执行则以谁为准
 * @param apps 应用列表
 */
export default function preFetch (apps: prefetchParams): void {
  requestIdleCallback(() => {
    const validApps: Array<prefetchParam> = []
    if (typeof apps === 'function') {
      filterPreFetchTarget(apps(), validApps)
    } else {
      filterPreFetchTarget(apps, validApps)
    }

    validApps.forEach((item) => {
      // 创建实例
      const app = new CreateApp({
        name: item.name,
        url: item.url,
        scopecss: !(
          (item.disableScopecss ?? microApp.disableScopecss) ||
          (item.shadowDOM ?? microApp.shadowDOM)
        ),
        useSandbox: !(item.disableSandbox ?? microApp.disableSandbox),
        macro: item.macro ?? microApp.macro,
      })

      app.isPrefetch = true
      appInstanceMap.set(item.name, app)
    })
  })
}
